import Blue from "~/core";
new Blue({
  name: "nav-toggle",
  selector: ".toggle",
  setup(toggle) {
    const navigation = document.querySelector('.navigation');
    let currFocus
    if (navigation) {
      const navigationClose = navigation.querySelector('.navigation__close');
      const newFocus = navigation.querySelector('.drawer__title')
      const focusableEls = navigation.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])')
      const lastFocusableEl = focusableEls[focusableEls.length - 1];

      const navigationLinks = navigation.querySelectorAll('a')
        this.$addEvents(toggle, "click enter", () => { 
          document.body.classList.add('nav-is-active')
          currFocus = document.activeElement
          newFocus.focus()
        });
        this.$addEvents(lastFocusableEl, 'focusout', () => {
          newFocus.focus()
        })
        this.$addEvents(navigationClose, 'click enter', () => {
          document.body.classList.remove('nav-is-active')
          currFocus.focus()
        });

        navigationLinks.forEach(e => {
          this.$addEvents(e, "click enter", () => {
            document.body.classList.remove('nav-is-active')
            currFocus.focus()
          });
        });
    }
  }
});

const scrollAnims = document.querySelectorAll('.js-animation-scroll');

// Create a new observer
let observer = new IntersectionObserver(function (entries) {
	//console.log(entries);
	entries.forEach(function (entry) {
		//console.log(entry.target);
    if (entry.isIntersecting) {
      const target = entry.target
      observer.unobserve(target)
      target.classList.add(target.dataset.animationClass)
      target.classList.add('is-visible')
    }
		
	});
});

if (scrollAnims) {

  // The elements to observe
  scrollAnims.forEach(e => {
    observer.observe(e)
  });

}
